import React from 'react';
import {
  getStatusColor,
  getStatusLabel,
} from '../../../../../../utils/inventory/transferStatusUtils';
import ModalInfoCard from '../../../../../../components/Cards/ModalInfoCard';
import SectionDivider from '../../../../../Dividers/SectionDivider';
import InfoRow from '../../../../../Rows/InfoRow';
import { InventoryTransferDetailLineDTO } from '../../../../../../types/inventory/transfer/InventoryTransferTypes';

interface Props {
  details: InventoryTransferDetailLineDTO[];
  reason?: string | null;
  status: string;
}

const TransferInfoSection: React.FC<Props> = ({
  details,
  reason,
  status,
}) => {
  return (
    <>
      {/* ✅ Título + divisor */}
      <SectionDivider title="Información del Traslado" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {/* ✅ Productos */}
        <ModalInfoCard title="Productos">
          {details && details.length > 0 ? (
            <div className="space-y-1">
              {details.map((d) => (
                <InfoRow
                  key={d.id}
                  label={d.productName}
                  value={`${Number(d.quantity).toFixed(2)} ${d.unitCode ?? ''}`}
                />
              ))}
            </div>
          ) : (
            <InfoRow value="Sin productos" />
          )}
        </ModalInfoCard>

        {/* ✅ Estado */}
        <ModalInfoCard title="Estado del Traslado">
          <InfoRow
            value={
              <span
                className={`w-fit rounded-md px-3 py-1 text-xs font-bold ${getStatusColor(
                  status
                )}`}
              >
                {getStatusLabel(status)}
              </span>
            }
          />
        </ModalInfoCard>

        <div className="md:col-span-2">
          <ModalInfoCard title="Razón">
            <InfoRow value={reason?.trim() || '—'} />
          </ModalInfoCard>
        </div>
      </div>
    </>
  );
};

export default TransferInfoSection;
